import { CalculatorBloodComponents } from "./calculators/calculatorBloodComponents";
import { CalculatorBloodTypeParent } from "./calculators/calculatorBloodTypeParent";
import { CalculatorBloodTypeChild } from "./calculators/calculatorBloodTypeChild";
import { CalculatorBloodDonation } from "./calculators/calculatorBloodDonation";
import { CalculatorChildbirth } from "./calculators/calculatorChildbirth";
import { CalculatorFertility } from "./calculators/calculatorFertility";
import { CalculatorBloodAlcohol } from "./calculators/calculatorBloodAlcohol";
import { CalculatorBmi } from "./calculators/calculatorBmi";

// calculators
window.calculators = {
    bloodAlcoholInit: () => new CalculatorBloodAlcohol(),
    bloodComponentsInit: () => new CalculatorBloodComponents(),
    bloodDonationInit: () => new CalculatorBloodDonation(),
    bloodTypeChildInit: () => new CalculatorBloodTypeChild(),
    bloodTypeParentInit: () => new CalculatorBloodTypeParent(),
    bmiInit: () => new CalculatorBmi(),
    fertilityInit: () => new CalculatorFertility(),
    childbirthInit: () => new CalculatorChildbirth()
}